export const GET_BIOMARKER_SUCCESS = "GET_BIOMARKER_SUCCESS";
